export enum ActivityPatchModeEnum {
  Single = 0,
  MultiActivity_Single = 1,
  MultiActivity_Group = 2,
}
